import React from 'react';
import PropTypes from 'prop-types';
import ModuleBlock from '../ModuleBlock';
import ModuleService from '../../../../../services/module';

class QuizModuleBlock extends React.Component {
    static propTypes = {
        app: PropTypes.object.isRequired,
    };

    render() {
        return (
            <ModuleBlock
                app={this.props.app}
                module={ModuleService.getModule(ModuleService.QUIZ)}
            />
        );
    }
}

export default QuizModuleBlock;



// WEBPACK FOOTER //
// src/components/application/ApplicationFull/ModuleBlock/QuizModuleBlock/QuizModuleBlock.js